export interface WineType {
    id: string;
    label: string;
    color: string;
    short: string;
}

// "moelleux" was removed as a standalone type on 2026-07-17: it now merges
// into "blanc" everywhere a wine is imported or displayed (see WineRepository
// and ParseCSV normalization).
export const TYPES: WineType[] = [
  { id: "rouge", label: "Rouges", color: "#9B2020", short: "Rouge" },
  { id: "blanc", label: "Blancs", color: "#C49A3C", short: "Blanc" },
  { id: "rose", label: "Rosés", color: "#C97B8A", short: "Rosé" },
  { id: "effervescent", label: "Effervescents", color: "#7A9FB5", short: "Efferv." },
  ];
